// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"511":"KinoPage","754":"NotFoundPage"}[chunkId] || chunkId) + "." + {"30":"131acc64","220":"2953de3d","263":"7aa0e4e6","496":"fbc26f54","511":"59b4df06","608":"b16889c2","754":"6f038f5d","987":"ad6d6a5b"}[chunkId] + ".chunk.js";
};